const save = (key, data) => localStorage.setItem(key, JSON.stringify(data));

const destroy = (key) => localStorage.removeItem(key);

const get = (key) => {
    try {
        return JSON.parse(localStorage.getItem(key)) || {};
    } catch (e) {
        return {};
    }
};


export default {save, get, destroy};



// WEBPACK FOOTER //
// ./src/helpers/localStorage.js